export { default } from './NewsletterRegistration';
